import Utils from 'src/utils';
import { departmentsTreeToOptions, getDepartmentsTree } from 'src/helpers/modular/departmentsUtil';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_DEPARTMENTS_REQUEST';
export const FAIL = 'LOAD_DEPARTMENTS_FAIL';
export const SUCCESS = 'LOAD_DEPARTMENTS_SUCCESS';

export const REQUEST_WITH_JOBS = 'LOAD_DEPARTMENTS_WITH_JOBS_REQUEST';
export const FAIL_WITH_JOBS = 'LOAD_DEPARTMENTS_WITH_JOBS_FAIL';
export const SUCCESS_WITH_JOBS = 'LOAD_DEPARTMENTS_WITH_JOBS_SUCCESS';

export const PUT_REQUEST = 'PUT_DEPARTMENT_REQUEST';
export const PUT_FAIL = 'PUT_DEPARTMENT_FAIL';
export const PUT_SUCCESS = 'PUT_DEPARTMENT_SUCCESS';

export const POST_REQUEST = 'POST_DEPARTMENT_REQUEST';
export const POST_FAIL = 'POST_DEPARTMENT_FAIL';
export const POST_SUCCESS = 'POST_DEPARTMENT_SUCCESS';

export const DELETE_REQUEST = 'DELETE_DEPARTMENT_REQUEST';
export const DELETE_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const DELETE_FAIL = 'DELETE_DEPARTMENT_FAIL';

export const OPTIONS_SUCCESS = 'LOAD_DEPARTMENTS_OPTIONS_SUCCESS';

const loadDepartmentsWithJobsRequest = () => ({ type: REQUEST_WITH_JOBS });
const loadDepartmentsWithJobsFail = (err) => ({ type: FAIL_WITH_JOBS, err });
const loadDepartmentsWithJobsSuccess = (departments) => ({ type: SUCCESS_WITH_JOBS, departments });

const putDepartmentRequest = () => ({ type: PUT_REQUEST });
const putDepartmentFail = (err) => ({ type: PUT_FAIL, err });
const putDepartmentSuccess = (department) => ({ type: PUT_SUCCESS, department });

const postDepartmentSuccess = (department) => ({ type: POST_SUCCESS, department });
const postDepartmentRequest = () => ({ type: POST_REQUEST });
const postDepartmentFail = (error) => ({ type: POST_FAIL, error });

const deleteDepartmentRequest = (departments) => ({ type: DELETE_REQUEST, departments });
const deleteDepartmentFail = (error) => ({ type: DELETE_FAIL, error });
const deleteDepartmentSuccess = (departmentId) => ({ type: DELETE_SUCCESS, departmentId });
const loadDepartmentsOptionsSuccess = (departmentsOptions) => ({ type: OPTIONS_SUCCESS, departmentsOptions });

export const loadDepartments = () => (dispatch) => {
  dispatch(loadDepartmentsWithJobsRequest());

  return communicate({ url: 'Departments/WithJobs' })
    .then(({ data: { Data: departments } }) => {
      dispatch(loadDepartmentsWithJobsSuccess(departments));
      const tree = getDepartmentsTree(departments);
      const options = departmentsTreeToOptions(tree);
      dispatch(loadDepartmentsOptionsSuccess(options));
    })
    .catch((e) => {
      dispatch(loadDepartmentsWithJobsFail(e));
      toastrError(e);
    });
};

export const putDepartment = (department) => (dispatch) => {
  dispatch(putDepartmentRequest(department));
  return communicate({ url: 'Departments', method: 'put', data: department })
    .then((response) => {
      dispatch(putDepartmentSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((e) => {
      dispatch(putDepartmentFail(e));
      toastrError(e);
    });
};

export const postDepartment = (params) => (dispatch) => {
  dispatch(postDepartmentRequest());
  return communicate({ url: 'Departments', method: 'post', data: params }).then((response) => {
    dispatch(postDepartmentSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((e) => {
    dispatch(postDepartmentFail(e));
    toastrError(e);
    return Promise.reject(e);
  });
};

export const deleteDepartment = (departmentId) => (dispatch) => {
  dispatch(deleteDepartmentRequest(departmentId));
  return communicate({ url: 'Departments', method: 'delete', getParams: `?departmentId=${departmentId}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteDepartmentSuccess(departmentId));
    }).catch((e) => {
      dispatch(deleteDepartmentFail(e));
      toastrError(e);
    });
};

export const getDepartmentsByWorkShiftAssociations = (workShiftIds) => () => {
  const getParams = Utils.objects.getQueryStringFromObject({ workShiftIds });
  return communicate({ url: 'Departments', method: 'get', getParams })
    .then((response) => Promise.resolve(response.data.Data))
    .catch((err) => toastrError(err) && []);
};
